import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  DeleteFilled, DeleteOutlined, CheckCircleOutlined, CloseCircleOutlined,
} from '@ant-design/icons';
import {
  Button, Row, Col, Input, Radio, Spin, Form,
} from 'antd';
import './MatriculationForm.scss';
import { SessionExpiredException } from '../../../utils/errors';
import { checkMatriculation } from '../../../utils/sapUtils';
import { RequestWrapper } from '../../../dataSource/requests';

const MatriculationForm = (props): JSX.Element => {
  const { handleMATRICULA } = props;
  const [validating, setValidating] = useState([]);
  const [, setforceRender] = useState(1);

  useEffect(() => {
    return () => {
      setValidating([]);
    };
  }, []);

  const getItemIcon = (statuss: string): JSX.Element | null => {
    switch (statuss) {
      case 'success':
        return <CheckCircleOutlined style={{ color: 'green' }} />;

      case 'error':
        return <CloseCircleOutlined style={{ color: 'red' }} />;

      default:
        return null;
    }
  };

  const validateMatriculation = async (
    parameterMatriculationArray,
    value,
    index,
  ): Promise<void> => {
    const auxiliarArray = parameterMatriculationArray;
    const aux = validating;
    let result;

    if (value.length === 10) {
      try {
        const requestRef: RequestWrapper = checkMatriculation(value);
        result = await requestRef;
      } catch (error) {
        if (!(error instanceof SessionExpiredException)) {
          auxiliarArray[index].error = true;
          auxiliarArray[index].errorMessage = 'Ocorreu um erro ao validar a matrícula';
          auxiliarArray[index].status = 'error';
          aux[index] = false;

          setValidating(aux);

          handleMATRICULA(auxiliarArray);
        }

        return;
      }

      if (result.body.MT_VALIDAMATRICULA_Resp.ROWS.CODRETORNO === -1) {
        auxiliarArray[index].error = true;
        auxiliarArray[index].errorMessage = 'Matrícula não encontrada. Verifique e tente novamente.';
        auxiliarArray[index].status = 'error';
        aux[index] = false;
        setValidating(aux);
        handleMATRICULA(auxiliarArray);
        setforceRender((a) => a + 1);
      }

      if (result.body.MT_VALIDAMATRICULA_Resp.ROWS.CODRETORNO === 1) {
        auxiliarArray[index].error = false;
        auxiliarArray[index].errorMessage = '';
        auxiliarArray[index].status = 'success';
        aux[index] = false;
        setValidating(aux);
        handleMATRICULA(auxiliarArray);
        setforceRender((a) => a + 1);
      }
    }
  };

  const checkEquals = (id, index): void => {
    const { matriculationArray } = props;

    matriculationArray[index].equalsId = [];

    matriculationArray.forEach((m, index2) => {
      if (m.equalsId.includes(id)) {
        if (m.equalsId.length === 2) {
          matriculationArray[index2].equalsId = [];

          validateMatriculation(matriculationArray, m.value, index2);
        } else {
          matriculationArray[index2].equalsId = matriculationArray[index2]
            .equalsId.filter((maID) => maID !== id);
        }
      }
    });

    handleMATRICULA(matriculationArray);
  };

  const changeValue = (index, text, id): void => {
    const { matriculationArray } = props;

    const newMatriculationArray = [...matriculationArray];

    newMatriculationArray[index].value = text;
    const aux = validating;

    checkEquals(id, index);

    if (text.length === 10) {
      aux[index] = true;

      setValidating(aux);

      matriculationArray.forEach((m, index2) => {
        if (index2 !== index) {
          if (m.value === text) {
            newMatriculationArray[index].error = true;
            newMatriculationArray[index].errorMessage = 'Matricula já inserida';
            newMatriculationArray[index].status = 'error';
            aux[index] = false;

            setValidating(aux);

            newMatriculationArray[index].equalsId.push(matriculationArray[index2].id);
            newMatriculationArray[index].equalsId.push(id);
            newMatriculationArray[index]
              .equalsId = [...new Set(newMatriculationArray[index].equalsId)];
            handleMATRICULA(newMatriculationArray);
          }
        }
      });

      if (newMatriculationArray[index].error) return;

      validateMatriculation(newMatriculationArray, text, index);
    } else {
      newMatriculationArray[index].error = false;
      newMatriculationArray[index].errorMessage = '';
      newMatriculationArray[index].status = '';
    }

    handleMATRICULA(newMatriculationArray);
  };

  const removeMatriculation = (item, index): void => {
    const { matriculationArray } = props;

    const aux = validating;

    const newMatriculationArray = matriculationArray.filter((matricula) => item !== matricula);

    aux[index] = false;

    setValidating(aux);

    newMatriculationArray.forEach((m, index2) => {
      if (m.equalsId.includes(item.id)) {
        if (m.equalsId.length === 2) {
          newMatriculationArray[index2].equalsId = [];

          validateMatriculation(newMatriculationArray, m.value, index2);
        } else {
          newMatriculationArray[index2].equalsId = newMatriculationArray[index2]
            .equalsId.filter((maID) => maID !== item.id);
        }
      }
    });

    handleMATRICULA(newMatriculationArray);
  };

  const addMatriculation = (): void => {
    const { matriculationArray } = props;
    const newMatriculationArray = [
      ...matriculationArray,
      {
        id: matriculationArray[matriculationArray.length - 1].id + 1,
        value: '',
        error: false,
        status: '',
        errorMessage: '',
        equalsId: [],
      },
    ];

    handleMATRICULA(newMatriculationArray);
  };

  return (
    <div className="MatriculationForm">
      {
        props.matriculationArray.map((item, index) => (
          <Row key={index} gutter={[24]}>
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <Form.Item
                key={index}
                validateStatus={item.error ? 'error' : ''}
                help={item.error && item.errorMessage}
                className="codes"
                label=" "
              >
                <Input
                  value={item.value}
                  onChange={
                    (text): void => {
                      changeValue(index, text.target.value, item.id);
                    }
                  }
                  suffix={!validating[index] ? (getItemIcon(item.status)) : <Spin size="small" />}
                  className="input-registration"
                  placeholder="Matrícula com 10 dígitos"
                  maxLength={10}
                  disabled
                />
              </Form.Item>
              <div className="dynamic-delete-button-container">
                {
                  props.matriculationArray.length > 1
                    ? (
                      <Button
                        key={`deleteButton${index}`}
                        type="link"
                        className="dynamic-delete-button"
                        icon={<DeleteFilled />}
                        onClick={
                          (): void => {
                            removeMatriculation(item, index);
                          }
                        }
                        disabled
                      />
                    )
                    : (
                      <Button
                        key={`deleteButton${index}`}
                        type="link"
                        className="dynamic-delete-button"
                        icon={<DeleteOutlined />}
                        style={{ color: 'transparent', cursor: 'default' }}
                        disabled
                      />
                    )
                }
              </div>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              {
                props.matriculationArray[index].status === 'success'
                && (
                  <Form.Item
                    key={`matriculationStatus${item.id}`}
                    label="Status da matrícula"
                    name={['matriculationsStatus', item.id]}
                    validateTrigger={['onBlur']}
                    initialValue={
                      props.initalStatus[item.id] || 'PENDING_APPROVAL'
                    }
                  >
                    <Radio.Group buttonStyle="solid" className="matriculations-status-container">
                      <Radio.Button
                        className="radio-pending"
                        value="PENDING_APPROVAL"
                        disabled
                      >
                        Pendente
                      </Radio.Button>

                      <Radio.Button
                        className="radio-activated"
                        value="ACTIVATED"
                        disabled
                      >
                        Aprovada
                      </Radio.Button>

                      <Radio.Button
                        className="radio-deactivated"
                        value="DEACTIVATED"
                        disabled
                      >
                        Reprovada
                      </Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                )
              }
            </Col>
          </Row>
        ))
      }
      <Row gutter={[24]}>
        <Col xs={{ span: 24 }} lg={{ span: 12 }}>
          <Form.Item>
            <Button
              type="dashed"
              onClick={addMatriculation}
              ghost
              className="add-matriculation-button"
              disabled
            >
              ADICIONAR MATRÍCULA
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

MatriculationForm.propTypes = {
  initalStatus: PropTypes.objectOf(PropTypes.any),
  handleMATRICULA: PropTypes.func.isRequired,

  matriculationArray: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    value: PropTypes.string,
    error: PropTypes.bool,
    status: PropTypes.string,
    errorMessage: PropTypes.string,
    equalsId: PropTypes.arrayOf(PropTypes.any),
  })).isRequired,
};

MatriculationForm.defaultProps = {
  initalStatus: {},
};

export default MatriculationForm;
